export type BreakpointName = 'sm' | 'md' | 'lg' | 'xl' | 'xxl';

export const BREAKPOINT_WIDTHS: Record<BreakpointName, number> = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1400,
};
